document.addEventListener('turbolinks:load', () => {
    const sgScreen = document.getElementById('sgScreen')
    const sgBorderTop = document.getElementById('sgBorderTop')
    const sgBorderBottom = document.getElementById('sgBorderBottom')

    if (sgScreen !== null && sgBorderBottom !== null && sgBorderTop !== null) {
        resize()
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height

            sgBorderTop.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 22.0}px`
            sgBorderTop.style.borderTopRightRadius = `${currentSgScreenHeight / 22.0}px`
            sgBorderBottom.style.borderBottomLeftRadius = `${currentSgScreenHeight / 22.0}px`
            sgBorderBottom.style.borderBottomRightRadius = `${currentSgScreenHeight / 22.0}px`
        })
        resizeObserver.observe(sgScreen);
    }
});